// What each data type allows, mirroring CustomForms::FieldCommons

export const TYPE_META = {
  text:           { icon: 'fa-font',          tone: 'blue' },
  description:    { icon: 'fa-align-left',    tone: 'blue' },
  number:         { icon: 'fa-hashtag',       tone: 'teal' },
  float:          { icon: 'fa-calculator',    tone: 'teal' },
  date:           { icon: 'fa-calendar-alt',  tone: 'orange' },
  date_time:      { icon: 'fa-clock',         tone: 'orange' },
  yes_no:         { icon: 'fa-toggle-on',     tone: 'green' },
  checkbox:       { icon: 'fa-check-square',  tone: 'green' },
  select:         { icon: 'fa-list-ul',       tone: 'purple' },
  select_prefill: { icon: 'fa-list-alt',      tone: 'purple' },
  table:          { icon: 'fa-table',         tone: 'indigo' },
  e_sign:         { icon: 'fa-signature',     tone: 'pink' },
  photos:         { icon: 'fa-camera',        tone: 'pink' },
  static:         { icon: 'fa-heading',       tone: 'grey' },
  page_break:     { icon: 'fa-cut',           tone: 'grey' },
  section:        { icon: 'fa-layer-group',   tone: 'slate' }
}

export const typeMeta = (field) => TYPE_META[field.field_type === 'section' ? 'section' : field.data_type] || TYPE_META.text

export const isSection = (field) => field.field_type === 'section'

const REQUIREABLE = ['text', 'description', 'number', 'float', 'yes_no', 'checkbox', 'select', 'select_prefill', 'e_sign', 'photos', 'table']
export const requireable = (field) => REQUIREABLE.includes(field.data_type)

export const prefillable = (field) => ['text', 'description'].includes(field.data_type)

export const hasOptions = (field) => ['select', 'select_prefill'].includes(field.data_type)

// A page break has nothing to print, so it gets no position
export const positionable = (field) => !isSection(field) && field.data_type !== 'page_break'

export const hasFontSettings = (field) =>
  ['text', 'static', 'description', 'number', 'float', 'date', 'date_time', 'yes_no', 'checkbox', 'select', 'select_prefill', 'table'].includes(field.data_type)

export const DEFAULT_TABLE = {
  columns: [{ key: 'c1', name: '', type: 'text', width: null, options: [], source: null }],
  min_rows: 1, max_rows: 10, pdf_rows: 10, print_header: false, show_totals: false, prefill_with: null, default_rows: []
}

export const changeType = (field, dataType) => {
  const next = { ...field, data_type: dataType }
  if (!hasOptions(next)) {
    next.options = []
    next.has_extra_option = false
  }
  if (dataType !== 'select') { next.multi_option = false }
  if (!prefillable(next)) { next.prefill_with = null }
  if (!requireable(next)) { next.is_mandatory = false }
  next.table_columns = dataType === 'table' ? (field.table_columns || DEFAULT_TABLE) : null
  return next
}

export const DEFAULT_POSITION = {
  font: 'Helvetica', font_size: 10, font_size_auto: true, bold: false, italic: false, fill_color: '#000000'
}

export const defaultSize = (field) => {
  switch (field.data_type) {
    case 'yes_no':
    case 'checkbox':    return { w: 12, h: 12 }
    case 'description': return { w: 260, h: 60 }
    case 'e_sign':      return { w: 160, h: 60 }
    case 'photos':      return { w: 160, h: 120 }
    case 'table':       return { w: 420, h: 160 }
    default:            return { w: 160, h: 16 }
  }
}

// A field prints in its main box (option null), and a choice in one box per option

export const boxKey = (fieldId, option = null) => (option === null || option === undefined ? `${fieldId}` : `${fieldId}::${option}`)

export const parseBoxKey = (key) => {
  const [fieldId, ...rest] = String(key).split('::')
  return { fieldId: parseInt(fieldId, 10), option: rest.length ? rest.join('::') : null }
}

export const boxOf = (field, option = null) => (option === null ? field.position : (field.option_positions || {})[option]) || null

export const withBox = (field, option, position) => {
  if (option === null) { return { ...field, position } }
  const optionPositions = { ...(field.option_positions || {}) }
  if (position) { optionPositions[option] = position } else { delete optionPositions[option] }
  return { ...field, option_positions: optionPositions }
}

export const boxesOf = (field) => {
  const boxes = []
  if (field.position) { boxes.push({ key: boxKey(field.id), field, option: null, position: field.position }) }
  Object.entries(field.option_positions || {}).forEach(([option, position]) => {
    boxes.push({ key: boxKey(field.id, option), field, option, position })
  })
  return boxes
}

export const isPlaced = (field) => !!field.position || Object.keys(field.option_positions || {}).length > 0

export const optionChoices = (field, t) => {
  switch (field.data_type) {
    case 'yes_no':
      return [['true', t.yes_label], ['false', t.no_label]]
    case 'checkbox':
      return [['true', t.checked], ['false', t.unchecked]]
    case 'select': {
      const options = (field.options || []).map((option) => [option, option])
      return field.has_extra_option ? [...options, ['extra_option', t.other]] : options
    }
    case 'select_prefill':
      return (field.options || []).map((option) => [option, option])
    default:
      return []
  }
}

export const optionLabel = (field, option, t) => (optionChoices(field, t).find(([value]) => value === option) || [option, option])[1]
